import { render, staticRenderFns } from "./AudienceDetailsEditor.vue?vue&type=template&id=3edeec20&scoped=true&"
import script from "./AudienceDetailsEditor.vue?vue&type=script&lang=ts&"
export * from "./AudienceDetailsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceDetailsEditor.vue?vue&type=style&index=0&id=3edeec20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edeec20",
  null
  
)

export default component.exports